import { useEffect } from 'react';

import { useLoanProcessModal } from '@/components/loan-process/hooks/use-loan-process-modal';

export const StageOneLiberis = () => {
  const { setLoanStage } = useLoanProcessModal();

  useEffect(() => {
    setLoanStage(2, {
      viewOptions: {
        stageViewType: 'AGREEMENT_AND_APPROVALS',
        AGREEMENT_AND_APPROVALS: {
          openInEditMode: false,
        },
      },
    });
  }, []);

  return null;
};
